import { render } from "./NewCrawlNumStops.vue?vue&type=template&id=ccdf66ca&scoped=true"
import script from "./NewCrawlNumStops.vue?vue&type=script&lang=js"
export * from "./NewCrawlNumStops.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-ccdf66ca"

export default script